"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcSidebarBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_sidebar_constants_1 = require("./bc-sidebar-constants");
var bc_sidebar_constants_2 = require("./bc-sidebar-constants");
var bc_sidebar_constants_3 = require("./bc-sidebar-constants");
var bc_sidebar_constants_4 = require("./bc-sidebar-constants");
var bc_sidebar_constants_5 = require("./bc-sidebar-constants");
var bc_sidebar_constants_6 = require("./bc-sidebar-constants");
var bc_sidebar_constants_7 = require("./bc-sidebar-constants");
var bc_sidebar_constants_8 = require("./bc-sidebar-constants");
var bc_sidebar_constants_9 = require("./bc-sidebar-constants");
var bc_sidebar_constants_10 = require("./bc-sidebar-constants");
var bc_sidebar_constants_11 = require("./bc-sidebar-constants");
var BcSidebarBehavior = (function (_super) {
    __extends(BcSidebarBehavior, _super);
    function BcSidebarBehavior() {
        return _super.call(this) || this;
    }
    BcSidebarBehavior.setUpAll = function () {
        var sidebarElements = Array.from(document.querySelectorAll("section[class~='".concat(bc_sidebar_constants_4.SIDE_BAR, "']")));
        var elements = [];
        for (var _i = 0, sidebarElements_1 = sidebarElements; _i < sidebarElements_1.length; _i++) {
            var sidebarElement = sidebarElements_1[_i];
            var element = sidebarElement;
            var bc = new BcSidebarBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcSidebarBehavior.prototype._setUp = function () {
        this.configTypeFActions();
    };
    BcSidebarBehavior.prototype.configOpenCloseButtonEvent = function () {
        var _this = this;
        var openCloseButton = this.mySelf.querySelector("".concat(bc_sidebar_constants_2.SIDE_BAR_BUTTONS_QUERY, ":first-child"));
        openCloseButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            switch (_this.mySelf.getAttribute(bc_sidebar_constants_7.SIDE_BAR_STATUS_PROPERTY)) {
                case bc_sidebar_constants_1.SideBarStatus.close:
                    _this.open();
                    break;
                case bc_sidebar_constants_1.SideBarStatus.open:
                    _this.close();
                    break;
                default:
                    _this.open();
                    break;
            }
        });
    };
    BcSidebarBehavior.prototype.setHeightContent = function () {
        var content = this.mySelf.querySelector("".concat(bc_sidebar_constants_3.SIDE_BAR_PRINCIPAL_CONTENT));
        var height = document.documentElement.clientHeight;
        content.style.height = height + 'px';
        window.addEventListener('resize', function (event) {
            height = document.documentElement.clientHeight;
            content.style.height = height + 'px';
        });
    };
    BcSidebarBehavior.prototype.open = function () {
        var openCloseButton = this.mySelf.querySelector("".concat(bc_sidebar_constants_2.SIDE_BAR_BUTTONS_QUERY, ":first-child"));
        this.changeStatus(bc_sidebar_constants_1.SideBarStatus.open);
        this.configMainContent(true);
        openCloseButton.setAttribute("".concat(bc_sidebar_constants_11.ARIA_LABEL), "".concat(bc_sidebar_constants_11.ARIA_LABEL_BARRA_CONTRAER));
        openCloseButton.innerHTML = common_constants_1.BcCommonConstants.ICON_ARROW_RIGHT;
    };
    BcSidebarBehavior.prototype.close = function () {
        var openCloseButton = this.mySelf.querySelector("".concat(bc_sidebar_constants_2.SIDE_BAR_BUTTONS_QUERY, ":first-child"));
        this.changeStatus(bc_sidebar_constants_1.SideBarStatus.close);
        this.configMainContent(false);
        openCloseButton.setAttribute("".concat(bc_sidebar_constants_11.ARIA_LABEL), "".concat(bc_sidebar_constants_1.ARIA_LABEL_BARRA_EXPANDIR));
        openCloseButton.innerHTML = common_constants_1.BcCommonConstants.ICON_ARROW_LEFT;
    };
    BcSidebarBehavior.prototype.changeStatus = function (status) {
        this.mySelf.setAttribute(bc_sidebar_constants_7.SIDE_BAR_STATUS_PROPERTY, status);
    };
    BcSidebarBehavior.prototype.configMainContent = function (action) {
        var contenToShow = this.mySelf.querySelector("".concat(bc_sidebar_constants_2.SIDE_BAR_CONTENT_QUERY, ":first-child"));
        if (action) {
            contenToShow.classList.toggle(bc_sidebar_constants_5.SIDE_BAR_ACTIVE_CONTENT);
        }
        else {
            contenToShow.classList.remove(bc_sidebar_constants_5.SIDE_BAR_ACTIVE_CONTENT);
        }
    };
    BcSidebarBehavior.prototype.configCloseButtonEvent = function () {
        var _this = this;
        var closeButton = this.mySelf.querySelector("".concat(bc_sidebar_constants_2.SIDE_BAR_BUTTONS_QUERY, ":first-child"));
        closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.mySelf.setAttribute(bc_sidebar_constants_7.SIDE_BAR_STATUS_PROPERTY, bc_sidebar_constants_1.SideBarStatus.close);
        });
    };
    BcSidebarBehavior.prototype.configOpenButtonEventHide = function () {
        if (this.mySelf.getAttribute(bc_sidebar_constants_8.SIDE_BAR_TYPE_PROPERTY).includes(bc_sidebar_constants_9.SideBarType.hide)) {
            this.changeStatus(bc_sidebar_constants_1.SideBarStatus.open);
        }
    };
    BcSidebarBehavior.prototype.removeArrowButton = function () {
        this.removeDiferentSelectedButtons([bc_sidebar_constants_10.CLOSE_BUTTON_TEXT]);
    };
    BcSidebarBehavior.prototype.menuComponent = function () {
        var arrayTemp = [];
        var button = this.mySelf.querySelectorAll("".concat(bc_sidebar_constants_2.SIDE_BAR_BUTTONS_QUERY));
        button.forEach(function (item) {
            if (arrayTemp.includes(item.innerText)) {
                item.remove();
            }
            else {
                arrayTemp.push(item.innerText);
            }
        });
    };
    BcSidebarBehavior.prototype.closeEventKey = function () {
        var _this = this;
        var contenToShow = this.mySelf.querySelectorAll("".concat(bc_sidebar_constants_2.SIDE_BAR_BUTTONS_QUERY));
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            _this.closeComponentWithEsc(event, contenToShow);
        });
    };
    BcSidebarBehavior.prototype.closeComponentWithEsc = function (event, contenToShow) {
        if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
            if (this.mySelf.getAttribute(bc_sidebar_constants_8.SIDE_BAR_TYPE_PROPERTY) == bc_sidebar_constants_9.SideBarType.collapsible) {
                this.close();
            }
            else {
                this.mySelf.setAttribute(bc_sidebar_constants_7.SIDE_BAR_STATUS_PROPERTY, bc_sidebar_constants_1.SideBarStatus.close);
            }
            for (var index = 0; index < contenToShow.length; index++) {
                contenToShow[index].classList.remove(bc_sidebar_constants_5.SIDE_BAR_ACTIVE_CONTENT);
            }
        }
    };
    BcSidebarBehavior.prototype.removeDiferentSelectedButtons = function (wantedButtonText) {
        this.mySelf.querySelectorAll("".concat(bc_sidebar_constants_2.SIDE_BAR_BUTTONS_QUERY)).forEach(function (item) {
            if (!wantedButtonText.includes(item.textContent)) {
                item.remove();
            }
        });
        this.menuComponent();
    };
    BcSidebarBehavior.prototype.removeBothButtons = function () {
        this.removeArrowButton();
        this.removeCloseButton();
    };
    BcSidebarBehavior.prototype.removeCloseButton = function () {
        this.removeDiferentSelectedButtons([common_constants_1.BcCommonConstants.ICON_ARROW_LEFT]);
    };
    BcSidebarBehavior.prototype.configMenuItemsAction = function () {
        var itemsButton = this.mySelf.querySelectorAll("".concat(bc_sidebar_constants_2.SIDE_BAR_LI_NAV));
        for (var index = 0; index < itemsButton.length; index++) {
            var item = itemsButton[index];
            var button = item.querySelector('button');
            (0, helpers_1.addFocusable)(button, { tabindex: '0' });
            button.setAttribute('aria-label', "Seleccionado ".concat(index, " de ").concat(itemsButton.length));
            var idReference = button.getAttribute('aria-controls');
            if (idReference) {
                var elementContent = this.mySelf.querySelector("".concat(bc_sidebar_constants_2.SIDE_BAR_CONTENT_QUERY, "#").concat(idReference));
                var validateOpenId = this.validateOpenId(item, elementContent);
                button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, validateOpenId);
            }
        }
    };
    BcSidebarBehavior.prototype.accesibility = function () {
        var closeButton = this.mySelf.querySelector("".concat(bc_sidebar_constants_2.SIDE_BAR_BUTTONS_QUERY, ":first-child"));
        (0, helpers_1.addFocusable)(closeButton, { tabindex: '0' });
    };
    BcSidebarBehavior.prototype.validateOpenId = function (item, elementContent) {
        var _this = this;
        return function () {
            var _a;
            if (item.classList.contains(bc_sidebar_constants_6.SIDE_BAR_ACTIVE_ITEM)) {
                _this.removeActiveItem();
                elementContent.classList.remove(bc_sidebar_constants_5.SIDE_BAR_ACTIVE_CONTENT);
                _this.changeStatus(bc_sidebar_constants_1.SideBarStatus.close);
            }
            else {
                (_a = _this.mySelf
                    .querySelector("".concat(bc_sidebar_constants_2.SIDE_BAR_CONTENT_QUERY, ".").concat(bc_sidebar_constants_5.SIDE_BAR_ACTIVE_CONTENT))) === null || _a === void 0 ? void 0 : _a.classList.remove(bc_sidebar_constants_5.SIDE_BAR_ACTIVE_CONTENT);
                if (elementContent) {
                    _this.removeActiveItem();
                    item.classList.toggle(bc_sidebar_constants_6.SIDE_BAR_ACTIVE_ITEM);
                    elementContent.classList.toggle(bc_sidebar_constants_5.SIDE_BAR_ACTIVE_CONTENT);
                    _this.changeStatus(bc_sidebar_constants_1.SideBarStatus.open);
                }
            }
        };
    };
    BcSidebarBehavior.prototype.removeActiveItem = function () {
        var _a;
        (_a = this.mySelf.querySelector("".concat(bc_sidebar_constants_2.SIDE_BAR_LI_NAV, ".").concat(bc_sidebar_constants_6.SIDE_BAR_ACTIVE_ITEM))) === null || _a === void 0 ? void 0 : _a.classList.remove(bc_sidebar_constants_6.SIDE_BAR_ACTIVE_ITEM);
    };
    BcSidebarBehavior.prototype.configTypeFActions = function () {
        switch (this.mySelf.getAttribute(bc_sidebar_constants_8.SIDE_BAR_TYPE_PROPERTY)) {
            case bc_sidebar_constants_9.SideBarType.collapsible:
                this.setHeightContent();
                this.removeCloseButton();
                this.configOpenCloseButtonEvent();
                this.accesibility();
                this.closeEventKey();
                break;
            case bc_sidebar_constants_9.SideBarType.hide:
                this.setHeightContent();
                this.configMainContent(true);
                this.removeArrowButton();
                this.configCloseButtonEvent();
                this.configOpenButtonEventHide();
                this.accesibility();
                break;
            case bc_sidebar_constants_9.SideBarType.states:
                this.setHeightContent();
                this.removeBothButtons();
                this.configMenuItemsAction();
                this.closeEventKey();
                break;
            case bc_sidebar_constants_9.SideBarType.fixed:
                this.setHeightContent();
                this.configMainContent(true);
                this.removeBothButtons();
                break;
            default:
                this.removeBothButtons();
                break;
        }
    };
    return BcSidebarBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcSidebarBehavior = BcSidebarBehavior;
